<!-- <select class="form-select" (change)="selectLanguage($event.target.value)">
    <option value="en">English</option>
    <option value="vi">Vietnamese</option>
</select> -->

<ng-select [(ngModel)]="selectedOption" [clearable]="false" [searchable]="false"
    class="no-border-ng-select no-background-ng-select" (change)="selectLanguage($event)">
    <ng-option ng-selected="true" value="en">English</ng-option>
    <ng-option value="zh">Chinese</ng-option>
    <!-- <ng-option value="ms">Bahasa</ng-option> -->
</ng-select>